let refreshPromise = null;
let loginPromise = null;

export function dedupedRefresh(api) {
  if (!refreshPromise) {
    refreshPromise = api.post("/auth/refresh").finally(() => {
      refreshPromise = null;
    });
  }
  return refreshPromise;
}

export function dedupedLogin(fn) {
  if (!loginPromise) {
    loginPromise = fn().finally(() => {
      loginPromise = null;
    });
  }

  return loginPromise;
}
